import React, { useState } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
  CircularProgress,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import Grid2 from "@mui/material/Grid2";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

interface ResetPasswordProps {
  handleResetPassword: (newPassword: string, confirmPassword: string) => void;
  isLoading: boolean;
}

export default function ResetPassword(props: ResetPasswordProps) {
  const [values, setValues] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const resetPassword = (e: React.FormEvent) => {
    e.preventDefault();
    // check password are the same.
    props.handleResetPassword(values.newPassword, values.confirmPassword);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Typography variant="h4" component="h3" gutterBottom>
        Reset Password
      </Typography>
      <CssBaseline />
      <Box sx={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
        <Avatar sx={{
          m: 1,
          bgcolor: "secondary.main",
        }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        <Box component="form" sx={{
          width: "100%",
          mt: 1,
        }} noValidate>
          <TextField
            value={values.newPassword}
            onChange={handleInputChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="NewPassword"
            label="New Password"
            type="password"
            name="newPassword"
            autoComplete="new-password"
            autoFocus
          />
          <TextField
            value={values.confirmPassword}
            onChange={handleInputChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="ConfirmPassword"
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            autoComplete="new-password"
          />
          {props.isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Button
              onClick={resetPassword}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
            >
              Reset Password
            </Button>
          )}
          <Grid2 container>
            <Grid2 size={12}>
              <Typography>
                <Link to="/">
                  Login
                </Link>
              </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Container>
  );
}
